module.exports = __webpack_public_path__ + "static/home-evaluation-0103de8c77b892ed73d080bcd9ff1f16.jpg";